export const globals = {
  localize: function (key) {
    return this.$vuetify.lang.t('$vuetify.' + key)
  },
}
